// extracted by mini-css-extract-plugin
module.exports = {"felt":"tabletops_felt__30cRL"};